import styled from '@emotion/styled'

export const ProfilePicWrapper = styled.div`
  height: 200px;
`
